import gql from 'graphql-tag'

export default gql`query client($client_id: Int!){
  client(client_id: $client_id){
    client_id
    name
    is_supplier
    date_created
    client_type_id
    invoice_prefix
    client_type{
      client_type_id
      description
    }
    addresses{
      address_id
      full_address
    }
    contacts{
      contact_id
      first_name
      last_name
      position
      communication_methods{
        communication_method_id
        contact_info
        contact_medium_id
        contact_medium{
          contact_medium_id
          description
        }
      }
    }
    client_communication_methods{
      communication_method_id
      contact_info
      contact_medium_id
      contact_medium{
        contact_medium_id
        description
      }
    }
    projects{
      project_id
      name
      project_status{
        project_status_id
        description
      }
      
      total_fees
      total_hours
      total_budget
      total_invoiced
      total_writeoff
      total_credit_notes
      total_supplier_invoiced
      amount_to_invoice
    }
    minutes_worked_on_all_projects
  }
}`